import {
	Column,
	Item
} from 'devextreme-react/data-grid';
import { SyncDataGrid } from '../../../../components';
import MaterialCostPrintButton from './MaterialCostPrintButton';
import { MaterialCostReportParams } from '../types/MaterialCostReportParams';
import { useCallback } from 'react';

export default function MaterialCostGrid(props: { records: any[], reportParams: MaterialCostReportParams }) {

	const row = props.records[0] ?? {};
	var qtyVisibility: boolean[] = [];
	for (var i = 1; i <= 8; i++) {
		qtyVisibility.push(row["price" + i + "Visible"]);
	}

	const rowPrepared = useCallback((e: any) => {
		if (e.rowType === "data") {
			if (!e.data.sku) {
				e.rowElement.className += " dx-row-alt";
			}
		}
	}, []);

	return (
		<>
			<SyncDataGrid
				stateStorageKey={props.records.length > 0 ? 'material-cost-grid-v2' : ''}
				className="material-cost-grid"
				dataSource={props.records}
				keyExpr={['id']}
				height="62vh"
				onRowPrepared={rowPrepared}
				hidePrintButton={true}
				hideChooseColumnsButton={true}
				additionalToolbarItems={[
					<Item location='after' key="print">
						<MaterialCostPrintButton {...props.reportParams} />
					</Item>
				]}
			>
				<Column
					dataField={'productType'}
					caption={'Product Type'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'sku'}
					caption={'SKU'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'mfrSKU'}
					caption={'MFR SKU'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'mfrDescription'}
					caption={'MFR Description'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'description'}
					caption={'Description'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'thickness'}
					caption={'Thickness'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'dimension'}
					caption={'Dimension'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'squareFootage'}
					caption={'SF Unit'}
					dataType="string"
					alignment="center"
				/>
				<Column
					dataField={'fromToQty1'}
					caption={'From To Qty'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[0]}
				/>
				<Column
					dataField={'qty1Price'}
					caption={'$'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[0]}
				/>
				<Column
					dataField={'fromToQty2'}
					caption={'From To Qty'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[1]}
				/>
				<Column
					dataField={'qty2Price'}
					caption={'$'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[1]}
				/>
				<Column
					dataField={'fromToQty3'}
					caption={'From To Qty'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[2]}
				/>
				<Column
					dataField={'qty3Price'}
					caption={'$'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[2]}
				/>
				<Column
					dataField={'fromToQty4'}
					caption={'From To Qty'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[3]}
				/>
				<Column
					dataField={'qty4Price'}
					caption={'$'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[3]}
				/>
				<Column
					dataField={'fromToQty5'}
					caption={'From To Qty'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[4]}
				/>
				<Column
					dataField={'qty5Price'}
					caption={'$'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[4]}
				/>
				<Column
					dataField={'fromToQty6'}
					caption={'From To Qty'}
					dataType="string"
					allowSorting={false}
					visible={qtyVisibility[5]}
				/>
				<Column
					dataField={'qty6Price'}
					caption={'$'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[5]}
				/>
				<Column
					dataField={'fromToQty7'}
					caption={'From To Qty'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[6]}
				/>
				<Column
					dataField={'qty7Price'}
					caption={'$'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[6]}
				/>
				<Column
					dataField={'fromToQty8'}
					caption={'From To Qty'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[7]}
				/>
				<Column
					dataField={'qty8Price'}
					caption={'$'}
					dataType="string"
					alignment="center"
					visible={qtyVisibility[7]}
				/>
				<Column
					dataField={'startDate'}
					caption={'Start Date'}
					dataType="date"
					alignment="center"
				/>
				<Column
					dataField={'endDate'}
					caption={'End Date'}
					dataType="date"
					alignment="center"
				/>
			</SyncDataGrid>
		</>
	)
} 
